
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("mxO8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b6ab09e14a5b279$export$2e2bcd8739ae039);
/* view-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $1RDZV = parcelRequire("1RDZV");

var $3cMgR = parcelRequire("3cMgR");

var $ix0Ab = parcelRequire("ix0Ab");

var $bfW07 = parcelRequire("bfW07");

var $dV1IY = parcelRequire("dV1IY");

var $cAbbc = parcelRequire("cAbbc");

var $i2Hw2 = parcelRequire("i2Hw2");

var $cakbO = parcelRequire("cakbO");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");


var $6xDqp = parcelRequire("6xDqp");

var $l7iSF = parcelRequire("l7iSF");

var $dk7W5 = parcelRequire("dk7W5");

var $g90z9 = parcelRequire("g90z9");

var $16sa1 = parcelRequire("16sa1");

var $c5gEr = parcelRequire("c5gEr");

var $iTHAq = parcelRequire("iTHAq");
// eslint-disable-next-line jira/react/no-class-components
class $6b6ab09e14a5b279$var$RendererOld extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'Renderer';
    }
    static{
        this.defaultProps = {
            adf: undefined,
            placeholder: undefined
        };
    }
    constructor(props){
        super(props), this.onInlineCardClicked = (e, url)=>{
            const { linkActions: linkActions } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const event = e || window.event;
            event.preventDefault();
            if ((0, $l7iSF.isExternalLink)(url)) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(url, '_blank', 'noopener,noreferrer');
                return;
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const mouseEvent = event;
            const shouldOpenInNewTab = (0, $6xDqp.isCmdOrCtrlClick)(mouseEvent) || (0, $6xDqp.isMiddleClick)(mouseEvent);
            (0, $i2Hw2.default)(url, shouldOpenInNewTab, linkActions.push);
        }, this.onContentSelected = (e)=>{
            if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            !(e.target instanceof window.Element) || (0, $cAbbc.default)(e.target, e.currentTarget) || this.checkForMedia(e.target, e.currentTarget) || this.checkForTaskItem(e.target, e.currentTarget)) // This is to avoid entering edit mode when clicking on a link, task item, or video.
            e.stopPropagation();
        }, this.checkForMedia = (currentElement, topElement)=>{
            // If we reach the original div, we didn't find a video.
            if (!currentElement || currentElement === topElement) return false;
            // TODO: These checks are unsafe. Use the method outlined in
            // https://jdog.jira-dev.com/browse/BENTO-6367
            if (currentElement.className.includes?.('rich-media-item') || currentElement.className.includes?.('media-file-card-view') || currentElement.className.includes?.('media-viewer-popup') || currentElement.getAttribute('data-testId')?.includes('mediaAbuseModal')) return true;
            // Continue walking up the DOM tree looking for a video.
            return this.checkForMedia(currentElement.parentElement, topElement);
        }, // Can be refactored as an event handler
        // See platform/packages/editor/renderer/src/ui/Renderer/index.tsx
        // and `EventHandlers` from platform/packages/editor/editor-common/src/ui/EventHandlers/index.tsz
        this.checkForTaskItem = (currentElement, topElement, checkboxElement)=>{
            let foundCheckboxElement = checkboxElement;
            // Only consider the checkbox click as the valid event
            // i.e., clicking task item content should still open the edit-view
            if (currentElement?.getAttribute('type') === 'checkbox') foundCheckboxElement = currentElement;
            // If we reach the original element, we didn't find a task item.
            if (!currentElement || currentElement === topElement) return false;
            // Ensure it's an Atlaskit task item by checking `data-task-local-id`
            // See `platform/packages/elements/task-decision/src/components/TaskList.tsx`
            if (currentElement.getAttribute('data-task-local-id') != null && foundCheckboxElement != null) return true;
            // Continue walking up the DOM tree looking for a task item.
            return this.checkForTaskItem(currentElement.parentElement, topElement, foundCheckboxElement);
        }, this.spotlightTargetedOnExtensionNode = false, this.isEmpty = ()=>this.isAdfValueEmpty(), this.isAdfValueEmpty = ()=>{
            const { adf: adf } = this.props;
            // We should change this to an empty ADF object after this ticket is done: https://product-fabric.atlassian.net/browse/CS-235
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return !adf || (0, $dk7W5.isOnlyWhitespaceAdf)(adf);
        }, this.setNodeRef = (element)=>{
            this.node = element;
        };
        const { contextIdentifier: contextIdentifier, mediaProvider: mediaProvider, mentionProvider: mentionProvider, profileCardProvider: profileCardProvider, taskDecisionProvider: taskDecisionProvider } = this.props;
        this.node = null;
        this.dataProviders = new (0, $1RDZV.default)();
        this.dataProviders.setProvider('mediaProvider', mediaProvider);
        this.dataProviders.setProvider('mentionProvider', Promise.resolve(mentionProvider));
        if (!false) {
            let fetchAtStart = false;
            if (this.props.adf != null && typeof this.props.adf !== 'string') try {
                fetchAtStart = (0, $dk7W5.hasEmojiNode)(this.props.adf);
            } catch (_) {
                fetchAtStart = false;
            }
            this.dataProviders.setProvider('emojiProvider', (0, $dV1IY.getEmojiProviderWithCustomEmoji)(this.props.cloudId, this.props.loggedInUserAccountId, fetchAtStart));
        }
        if (contextIdentifier) this.dataProviders.setProvider('contextIdentifierProvider', Promise.resolve(contextIdentifier));
        this.dataProviders.setProvider('profilecardProvider', profileCardProvider);
        this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(taskDecisionProvider));
        this.eventHandlers = {
            smartCard: {
                onClick: this.onInlineCardClicked
            },
            link: {
                onClick: this.onInlineCardClicked
            }
        };
        this.extensionHandlers = {};
        if ((0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view')) this.extensionHandlers = (0, $g90z9.getRedactionExtensionHandler)(()=>{
            if (!this.spotlightTargetedOnExtensionNode) {
                this.spotlightTargetedOnExtensionNode = true;
                return props.fieldId || null;
            }
            return null;
        });
        if ((0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false)) (0, $bfW07.setupEditorExperiments)('jira');
        this.rendererNodeComponentOverrides = (0, $iTHAq.getSyncRendererNodeOverrides)();
    }
    componentDidUpdate(prevProps) {
        if ((0, $7jTnu.fg)('thor_resolve_description_field_jac')) {
            if (prevProps.taskDecisionProvider !== this.props.taskDecisionProvider) this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(this.props.taskDecisionProvider));
        }
    }
    render() {
        const { adf: adf, disableActions: disableActions, placeholder: placeholder } = this.props;
        if (this.isEmpty()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "color.text.subtlest"
        }, placeholder);
        this.spotlightTargetedOnExtensionNode = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "issue-view-media-renderer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            role: "presentation",
            onClick: this.onContentSelected,
            onKeyPress: this.onContentSelected,
            ref: this.setNodeRef,
            className: (0, $hcewu.default)([
                (0, $7jTnu.fg)('platform_editor_initial_width_change') && "_1bsb1osq _7cca15wb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default), {
            appearance: "comment",
            schema: (0, $8DB98.defaultSchema),
            document: (0, $dk7W5.removeCollectionFromAdf)(adf),
            dataProviders: this.dataProviders,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            allowAltTextOnImages: true,
            allowWrapCodeBlock: true,
            allowCopyToClipboard: true,
            media: {
                allowLinking: true,
                featureFlags: (0, $c5gEr.mediaFeatureFlags)()
            },
            portal: this.node,
            disableHeadingIDs: true,
            disableActions: disableActions,
            analyticsEventSeverityTracking: {
                enabled: true,
                severityDegradedThreshold: (0, $fc6bc8f8b3f07886$export$bd6f44214f84c29a),
                severityNormalThreshold: (0, $fc6bc8f8b3f07886$export$aa53f670803b96e)
            },
            unsupportedContentLevelsTracking: (0, $cakbO.getUnsupportedContentLevelsTracking)(),
            useSpecBasedValidator: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $7jTnu.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            smartLinks: {
                hideHoverPreview: false,
                ...(0, $l7iSF.smartLinksDefault)
            },
            UNSTABLE_allowTableResizing: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            UNSTABLE_allowTableAlignment: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            ...(0, $7jTnu.fg)('magma-3467-iv-renderer-sync-small-nodes') || (0, $7jTnu.fg)('magma-3467-iv-renderer-sync-media-nodes') || (0, $7jTnu.fg)('magma-3467-iv-renderer-sync-card-nodes') ? {
                nodeComponents: this.rendererNodeComponentOverrides
            } : {}
        })));
    }
}
const $6b6ab09e14a5b279$var$rendererStyles = null;
var $6b6ab09e14a5b279$export$2e2bcd8739ae039 = $6b6ab09e14a5b279$var$RendererOld;

});
const $fc6bc8f8b3f07886$export$bd6f44214f84c29a = 4102;
const $fc6bc8f8b3f07886$export$aa53f670803b96e = 3165;

parcelRegister("g90z9", function(module, exports) {

$parcel$export(module.exports, "getRedactionExtensionHandler", () => $e6a3ee86ab11edfa$export$fd010a581322717b);
$parcel$export(module.exports, "getRedactionExtension", () => $e6a3ee86ab11edfa$export$12bebc06194b8864);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $95gWV = parcelRequire("95gWV");
const $e6a3ee86ab11edfa$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $e6a3ee86ab11edfa$export$fd010a581322717b = (getSpotlightKey)=>({
        [$e6a3ee86ab11edfa$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
                    name: `redaction-marker-${key}`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {})
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {});
        }
    });

const $e6a3ee86ab11edfa$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $e6a3ee86ab11edfa$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("9lAvQ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $95gWV.RedactionMarker)
                }
            }
        }
    };
};

});
parcelRegister("95gWV", function(module, exports) {

$parcel$export(module.exports, "RedactionMarker", () => $78de67c3958b6156$export$5d1828a8b51af09e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5gWbO = parcelRequire("5gWbO");
const $78de67c3958b6156$var$redactionBarStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative'
});
function $78de67c3958b6156$export$5d1828a8b51af09e() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $eGOwo.fg)('jira-redaction-accessibility-followup')) return /*#__PURE__*/ (0, $gt9Am.jsx)($78de67c3958b6156$var$RedactionBar, {
        "aria-label": formatMessage((0, $5gWbO.default).redactionMarker)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "span",
        xcss: $78de67c3958b6156$var$redactionBarStyles
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $78de67c3958b6156$var$RedactionBar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_16fwhxg": (0, $awdRS.default)(CSS.supports('height', '1lh') ? '1lh' : '1.5em')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _1h1t1q25 _4t3immhw _bfhk1fxt _s7n4nkob _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5gWbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2401d645cf77231$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b2401d645cf77231$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    redactionMarker: {
        id: 'editor-extensions.redaction-extension.redaction-marker-aria-label',
        defaultMessage: 'Redacted content. Your organization has removed sensitive data.',
        description: 'Aria label for redaction marker.'
    }
});

});


parcelRegister("9lAvQ", function(module, exports) {

let $6ce265e0bc3ec318$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ce265e0bc3ec318$var$load("2w0Qi").then(()=>parcelRequire('aUqM7'));

});


parcelRegister("c5gEr", function(module, exports) {

$parcel$export(module.exports, "mediaFeatureFlags", () => $4eb4ae00e7515f1b$export$250985d9ea13242f);
/**
 * Feature flags should be defined individually in './feature-flags.js'
 * There is processing on that file to automate analytics discovery.
 * We import them here so they can be exported as one value and given to
 * Editor/Renderer/Media components.
 *
 * NOTE: The use of functions vs raw values is intentional. You must use
 * `mediaFeatureFlags()` vs `mediaFeatureFlags` due to the fact that these
 * flags won't be available immediately. This relates to SST and launchdarkly.
 * Otherwise the getters would be executed immediately and blank values
 * will be passed.
 */ const $4eb4ae00e7515f1b$export$250985d9ea13242f = ()=>({
        mediaInline: true,
        // TODO: remove after media team clean up securedClipboard: https://product-fabric.atlassian.net/browse/CXP-2664
        securedClipboard: true
    });

});

parcelRegister("iTHAq", function(module, exports) {

$parcel$export(module.exports, "getSyncRendererNodeOverrides", () => $b41b2562099174f2$export$137bebfd245dfe15);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");


const $b41b2562099174f2$var$cardRendererNodes = (parcelRequire("iKdJZ")).default;


const $b41b2562099174f2$var$mediaRendererNodes = (parcelRequire("b3tPL")).default;


const $b41b2562099174f2$var$smallRendererNodes = (parcelRequire("h9XsZ")).default;
const $b41b2562099174f2$export$137bebfd245dfe15 = (0, $LFmXM.default)(()=>{
    let nodeOverrides = {};
    if ((0, $7jTnu.fg)('magma-3467-iv-renderer-sync-card-nodes')) nodeOverrides = {
        ...nodeOverrides,
        ...$b41b2562099174f2$var$cardRendererNodes
    };
    if ((0, $7jTnu.fg)('magma-3467-iv-renderer-sync-media-nodes')) nodeOverrides = {
        ...nodeOverrides,
        ...$b41b2562099174f2$var$mediaRendererNodes
    };
    if ((0, $7jTnu.fg)('magma-3467-iv-renderer-sync-small-nodes')) nodeOverrides = {
        ...nodeOverrides,
        ...$b41b2562099174f2$var$smallRendererNodes
    };
    return nodeOverrides;
});

});
parcelRegister("iKdJZ", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-card-nodes', function() {
    return parcelRequire('gJPuF');
}, function() {
    return parcelRequire('ke5E3');
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});


parcelRegister("b3tPL", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-media-nodes', function() {
    return parcelRequire('fNJLN');
}, function() {
    return parcelRequire('fey0f');
});

});

parcelRegister("h9XsZ", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-small-nodes', function() {
    return parcelRequire('7esWo');
}, function() {
    return parcelRequire('bjNvJ');
});

});




$parcel$global.rlb("2tXQt")
//# sourceMappingURL=view-old.ae4b571f.js.map
